import React, { useEffect } from "react";
import { useState } from "react";
import "./scheme.css";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import ToastModal from "views/components/ToastModal";
import CircularProgress from "components/CircularProgress/CircularProgresss";

const SchemeSelection = ({
  schemeList,
  eligibleAmount,
  handleSchemeModal,
  onHandleSelected,
  selectedScheme,
  hanldeOpenSchemeModal,
  eligibleLoanAmount,
  revisedLoanAmount,
  setRevisedLoanAmount,
  revisedRoi,
  setRevisedRoi,
}) => {
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [enableLtvChange, setEnableLtvChange] = useState(false);
  const [enableRoiChange, setEnableRoiChange] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const selectedSchemeMinimumElgiblity = (
    (Number(eligibleLoanAmount) * Number(selectedScheme.ltv)) /
    100
  ).toFixed(2);
  const selectedSchemeMaximumElgiblity = (
    (Number(eligibleLoanAmount) * Number(selectedScheme.maximumLtvPercentage)) /
    100
  ).toFixed(2);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const getDeviationData = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DEVIATION_FINDALL,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!res?.data?.error_code && res?.data?.length > 0) {
      const hasActiveLtvChange = res?.data?.some(
        (item) => item?.code === "LTV_CHANGE" && item?.active === true
      );
      const hasRoiChange = res?.data?.some(
        (item) => item?.code === "ROI_CHANGE" && item?.active === true
      );
      setEnableLtvChange(hasActiveLtvChange);
      setEnableRoiChange(hasRoiChange);
    }else{
      setEnableLtvChange(false);
      setEnableRoiChange(false);
    }
  };

  useEffect(() => {
    getDeviationData();
  }, []);

  const handleRevisedAmountBlur = (e) => {
    if (e === "" || e === null || e === undefined) {
      return;
    }
    const value = Number(e)?.toFixed(2);
    if (
      value <= Math.round(selectedSchemeMaximumElgiblity)
    ) {
      setRevisedLoanAmount(Math.round(e));
    }else if (value > Math.round(selectedSchemeMaximumElgiblity)) {
      toastUpdate(
        "Error",
        `Revised loan amount should not greather than ${Math.round(selectedSchemeMaximumElgiblity)}`,
        true
      );
      setRevisedLoanAmount(Math.round(selectedSchemeMaximumElgiblity));
    }
  };

  const handleBlurRoi = (e) => {
     if (e === "" || e === null || e === undefined) {
      return;
    }
    const value = Number(e)?.toFixed(2);
    if (
      value < selectedScheme?.yearlyInterestRateMax &&
      value >= selectedScheme?.minimumAnnualInterestRate
    ) {
      setRevisedRoi(e);
    } else if (value > selectedScheme?.yearlyInterestRateMax) {
      toastUpdate(
        "Error",
        `Revised roi should be less than ${selectedScheme?.yearlyInterestRateMax}`,
        true
      );
      setRevisedRoi(selectedScheme?.yearlyInterestRateMax);
    } else if (value < selectedScheme?.minimumAnnualInterestRate) {
      toastUpdate(
        "Error",
        `Revised roi should be greather than ${selectedScheme?.minimumAnnualInterestRate}`,
        true
      );
      setRevisedRoi(selectedScheme?.minimumAnnualInterestRate);
    }
  };
  const handleContinueButton = async (e) => {
    if(Number(revisedRoi) === Number(selectedScheme?.yearlyInterestRate30Days)){
      toastUpdate("Error","Revised ROI can't be same as 1st slab",true);
      return false;
    }else{
      hanldeOpenSchemeModal();
    }
  }
  return (
    <div className="scheme-container">
      <table className="scheme-table">
        <thead>
          <tr>
            <th>Scheme Details</th>
            {schemeList.map((s) => (
              <th key={s.schemeCode}>
                {s.schemeCode}
                <div
                  onClick={() => handleSchemeModal(s.schemeCode)}
                  className="view-details"
                >
                  View Details
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Eligible Loan Amount</td>
            {schemeList.map((s) => (
              <td key={s.schemeCode}>
                ₹
                {Math.round(
                  (eligibleLoanAmount *
                    Number(
                       s.ltv?  s.ltv : s.maximumLtvPercentage
                    )) /
                  100
                )}
              </td>
            ))}
          </tr>

          <tr>
            <td>Revised Loan Amount</td>

            {schemeList.map((s, index) => {
              const selectedColumn = s.schemeCode === selectedScheme.schemeCode;

              return (
                <td key={s.schemeCode}>
                  {selectedColumn &&
                    enableLtvChange &&
                    Number(s?.ltv) !==
                      Number(s?.maximumLtvPercentage) && (
                      <input
                        className="number-input-container"
                        type="number"
                        step="0.01"
                        value={revisedLoanAmount}
                        onChange={(e) => setRevisedLoanAmount(e.target.value)}
                        onBlur={(e) => handleRevisedAmountBlur(e.target.value)}
                      />
                    )}
                </td>
              );
            })}
          </tr>

          <tr>
            <td>Min - Max</td>
            {schemeList.map((s) => (
              <td key={s.code}>{`₹${s.minLoanAmount.toLocaleString(
                "en-IN"
              )} - ₹${s.maxLoanAmount.toLocaleString("en-IN")}`}</td>
            ))}
          </tr>

          <tr>
            <td>Base ROI</td>
            {schemeList.map((s) => (
              <td key={s.code}>{s.yearlyInterestRateMax} %</td>
            ))}
          </tr>

          <tr>
            <td>1st Slab</td>
            {schemeList.map((s) => (
              <td key={s.code}>{s.yearlyInterestRate30Days} %</td>
            ))}
          </tr>

          {/* Final 1st Slab (INPUT) */}
          <tr>
            <td>Final 1st Slab (Effective)</td>

            {schemeList.map((s, index) => {
              const selectedColumn = s.schemeCode === selectedScheme.schemeCode;

              return (
                <td key={s.schemeCode}>
                  {selectedColumn &&
                    enableRoiChange &&
                    Number(s?.yearlyInterestRate30Days) !==
                      Number(s?.minimumAnnualInterestRate) && (
                      <input
                        className="number-input-container"
                        type="number"
                        step="0.01"
                        value={revisedRoi}
                        onChange={(e) => setRevisedRoi(e.target.value)}
                        onBlur={(e) => handleBlurRoi(e.target.value)}
                      />
                    )}
                </td>
              );
            })}
          </tr>

          <tr>
            <td>2nd Slab</td>
            {schemeList.map((s) => (
              <td key={s.code}>{s.yearlyInterestRate60Days} %</td>
            ))}
          </tr>

          <tr>
            <td>3rd Slab</td>
            {schemeList.map((s) => (
              <td key={s.code}>{s.yearlyInterestRate90Days} %</td>
            ))}
          </tr>

          <tr className="select-row">
            <td>Select Scheme</td>
            {schemeList.map((s) => (
              <td key={s.schemeCode}>
                <span className="checkboxContainer">
                  <input
                    type="radio"
                    name="scheme"
                    checked={selectedScheme?.schemeCode === s.schemeCode}
                    onChange={() => onHandleSelected(s)}
                    className="checkbox"
                  />
                  <span className="schemeCode">{s.schemeCode}</span>
                </span>
              </td>
            ))}
          </tr>
        </tbody>
      </table>

      <div className="footer">
        <button
          disabled={!selectedScheme}
          onClick={(e) => handleContinueButton(e)}
        >
          Continue
        </button>
      </div>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
    </div>
  );
};

export default SchemeSelection;
